import * as z from "zod/v4";

const _emailBuilderVariantImageSchema = z.object({
  url: z.string(),
  title: z.string(),
  dimensions: z.object({
    width: z.number().optional(),
    height: z.number().optional(),
  }),
  variantId: z.string(),
  updatedAt: z.iso.datetime(),
});
const emailBuilderVariantImageSchema: z.ZodType<EmailBuilderVariantImage> =
  _emailBuilderVariantImageSchema;
export interface EmailBuilderVariantImage
  extends z.infer<typeof _emailBuilderVariantImageSchema> {}

export const getProductImages = {
  name: "getProductImages" as const,
  input: z.object({
    searchString: z.string(),
    pageSize: z.number(),
    afterCursor: z.string().optional(),
  }),
  output: z.object({
    images: z.array(emailBuilderVariantImageSchema),
    nextPageCursor: z.string().optional(),
  }),
};

export interface ImageSearchInput
  extends z.infer<typeof getProductImages.input> {}
export interface ImageSearchResult
  extends z.infer<typeof getProductImages.output> {}
